import $ from 'jquery';
import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import aa from 'search-insights';
import {
  configure,
  infiniteHits,
  pagination,
  searchBox,
  sortBy,
  refinementList
} from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import {
  scrollToElement,
  getQueryParamsAsObject,
  decodeHtml
} from './lib/utilities';
import { AJAX_URL } from './config';

const formContainer = '.registered-dieticians';
const hitsContainer = '#algolia-dieticians-hits';
const categoriesContainer = '#algolia-container';
const sortbyContainer = '#algolia-sortby';
const paginationContainer = '#algolia-dieticians-pagination';
const queryParams = getQueryParamsAsObject();
const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlDieticiansIndex.indexName;
const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});

if ((queryParams || {}).q) setTimeout(scrollToTop, 500);

if ($(formContainer).length > 0) {
  // Instantiate instantsearch.js
  const search = instantsearch({
    searchClient: algoliasearch(appId, apiKey),
    indexName,
    routing: {
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[indexName];
          return {
            q: indexUiState.query,
            pagination: indexUiState.page,
            location:
              indexUiState.refinementList &&
              indexUiState.refinementList.location,
            areas_of_expertise:
              indexUiState.refinementList &&
              indexUiState.refinementList.areas_of_expertise,
            insurance_accepted:
              indexUiState.refinementList &&
              indexUiState.refinementList.insurance_accepted
          };
        },
        routeToState(routeState) {
          return {
            [indexName]: {
              query: routeState.q,
              refinementList: {
                location: routeState.location,
                areas_of_expertise: routeState.areas_of_expertise,
                insurance_accepted: routeState.insurance_accepted
              }
            }
          };
        }
      }
    }
  });
  search.use(insightsMiddleware);

  const widgetConfig = configure({
    hitsPerPage: 24,
    facetingAfterDistinct: true,
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__',
    disjunctiveFacets: ['location', 'areas_of_expertise', 'insurance_accepted']
  });
  const widgetSearchBox = searchBox({
    container: formContainer,
    placeholder: 'Search by Keyword...',
    queryHook: (query, search) => search(query),
    poweredBy: false,
    searchAsYouType: true,
    reset: false,
    showSubmit: false,
    searchOnEnterKeyPressOnly: true,
    wrapInput: true,
    cssClasses: {
      submit: ['btn btn--primary'],
      input: ['site-search']
    },
    templates: {
      submit: `Search`
    }
  });

  const widgetHits = infiniteHits({
    container: hitsContainer,
    escapeHTML: false,
    cssClasses: {
      loadMore: [
        'btn',
        'btn--primary',
        'btn--load-more',
        'btn--loose',
        'btn--xl'
      ]
    },
    templates: {
      empty: 'No results were found for "<strong>{{query}}</strong>".',
      item: window.wp.template('product-hit'),
      showMoreText: 'Load More'
    }
  });
  const widgetPagination = pagination({
    container: paginationContainer,
    templates: {
      next: '<i class="icon-caret-double-right"></i>',
      previous: '<i class="icon-caret-double-left"></i>'
    },
    maxPages: 8,
    showFirst: false,
    showLast: false,
    scrollTo: false,
    cssClasses: {
      noRefinementRoot: 'u--display-none'
    }
  });
  const widgetRefinementListLocations = refinementList({
    container: '#algolia-refinement-list-locations',
    attribute: 'locations',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    sortBy: ['name:asc'],
    limit: 50,
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    }
  });
  const widgetRefinementListAreas = refinementList({
    container: '#algolia-refinement-list-expertise',
    attribute: 'areas_of_expertise',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    limit: 50,
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    }
  });
    const widgetRefinementListInsurance = refinementList({
    container: '#algolia-refinement-list-insurance',
    attribute: 'insurance_accepted',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    limit: 50,
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    }
  });

  let userToken = '';

  search.addWidgets([
    widgetConfig,
    widgetRefinementListLocations,
    widgetRefinementListAreas,
    widgetRefinementListInsurance,
    widgetHits
  ]);

  // Start search
  search.start();
  search.on('render', () => {
    // only re-init toggles inside the hits container
    window.wlInitToggles?.('#algolia-dieticians-hits');
  });

  // Get search queryID, needed for analytics payload.
  const getQueryID = () => search.helper.lastResults.queryID;

  // Focus input
  $(formContainer).find('input').attr('type', 'search').select();

  // Init Algolia analytics
  aa('init', { appId, apiKey });
  aa('getUserToken', null, (err, algoliaUserToken) => {
    if (err) return;
    userToken = algoliaUserToken;
  });

  // Add event listeners to scroll to search content
  $('html').on('submit', formContainer, scrollToTop);
  $('html').on('click', `${paginationContainer} a`, scrollToTop);
  $('html').on('change', `${categoriesContainer}`, scrollToTop);
  $('html').on('click', `${hitsContainer} a.search-hit`, (event) => {
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName: 'Hit Clicked',
      index: indexName,
      objectIDs: [event.currentTarget.getAttribute('data-object-id')],
      positions: [
        parseInt(event.currentTarget.getAttribute('data-object-position'))
      ],
      queryID: getQueryID()
    });
  });
}

function scrollToTop(event) {
  if (event) event.preventDefault();
  scrollToElement(categoriesContainer);
}
